import {
  Box,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { memo } from 'react';

import ChevronIcon from 'common/shared-ui/src/icons/ChevronIcon';

const StyledGrid = styled(Grid)(({ theme }) => ({
  height: 40,
  backgroundColor: '#DCDFF4',
  borderRadius: theme.spacing(4),
}));

const DateSwitcher = ({ dateFrom, dateTo, handleToggle }) => {
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('lg'),
  );
  const isSmallestScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('sm'),
  );
  return (
    <StyledGrid container wrap='nowrap'>
      <IconButton disableRipple onClick={handleToggle} direction='left'>
        <ChevronIcon
          direction='left'
          width={isSmallScreen ? 20 : 24}
          height={isSmallScreen ? 20 : 24}
          viewBox='0 0 24 24'
        />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: isSmallestScreen ? 'column' : 'row',
        }}
      >
        <Typography
          variant={isSmallScreen ? (isSmallestScreen ? 'h6' : 'h5') : 'h4'}
          sx={{
            fontWeight: 600,
          }}
        >
          {dayjs(dateFrom).format('DD MMMM YYYY')}
        </Typography>
        <Box>
          <Typography
            variant={isSmallScreen ? 'h6' : 'h4'}
            sx={{
              fontWeight: 600,
              marginRight: 2,
              marginLeft: 2,
              display: isSmallestScreen ? 'none' : 'block',
            }}
          >
            —
          </Typography>
        </Box>
        <Typography
          variant={isSmallScreen ? (isSmallestScreen ? 'h6' : 'h5') : 'h4'}
          sx={{
            fontWeight: 600,
          }}
        >
          {dayjs(dateTo).format('DD MMMM YYYY')}
        </Typography>
      </Box>
      <IconButton disableRipple onClick={handleToggle} direction='right'>
        <ChevronIcon
          direction='right'
          width={isSmallScreen ? 20 : 24}
          height={isSmallScreen ? 20 : 24}
          viewBox='0 0 24 24'
        />
      </IconButton>
    </StyledGrid>
  );
};

export default memo(DateSwitcher);
